const rutaBackendNest="https://backend-nest-informes.vercel.app"
//const rutaBackendNest="http://localhost:3001"
export default rutaBackendNest